import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { Notice, CPanel, H4 } from '@appcues/component-library';
import Plans from 'components/SubscriptionPicker/Plans';
import Controls from 'components/SubscriptionPicker/Controls';
import Loader from 'components/Common/Loader';
import CardLink from 'components/SubscriptionPicker/CardLink';

import {
  DEFAULT_PLAN_LIMIT,
  PLAN_TYPES,
  PLAN_TO_TIER_MAPPINGS,
} from 'constants/plans';
import { addCard, getSettingsFromPlanId } from 'utils/stripe';

import * as currentModalActions from 'actions/currentModal';
import * as metaActions from 'actions/account/meta';
import { setPaymentFailed, setPaymentSuccess } from 'actions/billing';
import { trackEvent } from 'actions/events';

import {
  selectAccountMeta,
  selectAccountMetaSynced,
} from 'reducers/account/meta';
import { selectUser, selectUserId, selectUserSynced } from 'reducers/user';
import {
  selectAccountAllTimeStats,
  selectAccountAllTimeStatsSynced,
} from 'reducers/account/allTimeStats';

export class SubscriptionPicker extends Component {
  // In the future, we'll want to fetch the prices/plans from Stripe.
  state = {
    planInterval: 'yearly',
    planLimit: DEFAULT_PLAN_LIMIT,
    planType: 'standard',
  };

  componentDidMount = () => {
    const {
      account: { targetStripePlan },
    } = this.props;

    if (targetStripePlan) {
      const planType = PLAN_TYPES.find(
        type => type.id === PLAN_TO_TIER_MAPPINGS[targetStripePlan.id]
      );

      if (planType) {
        let planId = targetStripePlan.id;

        if (planType.pricePlanId) {
          planId = planId.replace(planType.id, planType.pricePlanId);
        }

        const targetPlanSettings = getSettingsFromPlanId(planId);

        const startingLimit = targetPlanSettings.limit || DEFAULT_PLAN_LIMIT;

        this.setState({ planLimit: startingLimit });
      }
    }
  };

  onChange = (prop, val) => {
    this.setState({
      [prop]: val,
    });
  };

  onPlanLimitChange = ({ value }) => this.onChange('planLimit', value);

  onPlanIntervalChange = value => this.onChange('planInterval', value);

  render() {
    const {
      account,
      user,
      allTimeStats,
      actions,
      synced,
      userId,
      paymentFailedMessage,
      className,
    } = this.props;

    if (!synced) {
      return <Loader />;
    }

    const userWithAccountId = {
      email: user.email,
      id: userId.replace('simplelogin:', ''),
      accountId: account.id,
    };

    const currentStripeId = account.stripeId;
    const targetPlan = account.targetStripePlan;

    // Set the defaults (for if there is some error or it is a custom plan)
    const { planInterval, planLimit, planType } = this.state;

    return (
      <div className={className}>
        {paymentFailedMessage && (
          <PaymentErrorBanner>
            <Notice className="alert-error">{`${paymentFailedMessage} Please try again.`}</Notice>
          </PaymentErrorBanner>
        )}
        <CPanel>
          <CPanel.Header>
            <H4 type="secondary">Plan Options</H4>
          </CPanel.Header>
          {!targetPlan && (
            <Controls
              allTimeStats={allTimeStats}
              onChangeLimit={this.onPlanLimitChange}
              onChangeInterval={this.onPlanIntervalChange}
              planLimit={planLimit}
              planInterval={planInterval}
            />
          )}
          <Plans
            actions={actions}
            planType={planType}
            planInterval={planInterval}
            planLimit={planLimit}
            user={userWithAccountId}
            targetPlan={targetPlan}
          />
          {!currentStripeId && (
            <CardLink addCard={addCard} userWithAccountId={userWithAccountId} />
          )}
        </CPanel>
      </div>
    );
  }
}

const PaymentErrorBanner = styled.div`
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;

  .alert-error {
    margin: 0;
    justify-content: center;
  }
`;

function mapStateToProps(state) {
  const synced =
    selectUserSynced(state) &&
    selectAccountMetaSynced(state) &&
    selectAccountAllTimeStatsSynced(state);

  return {
    firebase: state.firebase || {},
    account: selectAccountMeta(state),
    user: selectUser(state),
    allTimeStats: selectAccountAllTimeStats(state),
    userId: selectUserId(state),
    synced,
    paymentFailedMessage: state.billing.paymentFailedMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...currentModalActions,
        ...metaActions,
        setPaymentFailed,
        setPaymentSuccess,
        trackEvent,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPicker);
